<nb-card>
  <nb-card-header>
    <button
      class="close"
      nbButton
      status="danger"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <h6 *ngIf="!purchase">Không tìm thấy dữ liệu</h6>

    <ngx-view-purchase
      *ngIf="purchase"
      [shopId]="shopId"
      [shop]="shop"
      [purchase]="purchase"
      [mode]="'detail'"
      (onClosed)="close()"
      (onDelete)="onDelete($event)"
    >
    </ngx-view-purchase>
  </nb-card-body>
</nb-card>
